<template lang="pug">
  div.counts
    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.green--text {{ item.candidates_count }}
      span Candidates

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_queue {{ item.top_cbr_reserve_queue_count }}|{{ item.top_cbr_exchange_queue_count }}
      span Top CBR

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_mijn {{ item.mijn_cbr_queue_count }}
      span Mijn CBR

    v-tooltip(top)
      template(v-slot:activator="{ on }")
        span(v-on="withTooltip ? on : null").counts__item.counts__item_slots {{ item.slots_count }}
      span Slots
</template>

<script>
  export default {
    props: {
      item: {
        Object,
        required: true,
      },
      withTooltip: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .counts {
    display: flex;
    align-items: center;
    border-top: 1px solid $border-color;
    &__item {
      padding: 4px 0;
      width: 25%;
      text-align: center;
      color: $label-color;
      border-right: 1px solid $border-color;
      &_queue {
        color: #79880E;
      }
      &_mijn {
        color: #3c16e9;
      }
      &_slots {
        border: 1px solid $warning-color;
        color: $warning-color;
      }
    }
  }
</style>